<template>
  <div>
    <v-card-actions class="justify-space-around px-0">
      <v-btn icon text @click="prev">
        <v-icon color="#29284c">mdi-chevron-left</v-icon>
      </v-btn>
      <v-item-group v-model="onboarding" class="text-center" mandatory>
        <template v-if="homeworks">
          <v-item
            v-for="n in homeworks.length + 1"
            :key="`btn-${n}`"
            v-slot:default="{ active, toggle }"
          >
            <v-btn icon @click="toggle" :input-value="active">
              <v-icon color="#29284c">mdi-record</v-icon>
            </v-btn>
          </v-item>
        </template>
      </v-item-group>
      <v-btn icon text @click="next">
        <v-icon color="#29284c">mdi-chevron-right</v-icon>
      </v-btn>
    </v-card-actions>
    <v-window v-model="onboarding">
      <v-row align="center" justify="center">
        <v-window-item>
          <app-add @new-exercise="newExercise">Add New Exercise</app-add>
        </v-window-item>
        <template v-if="homeworks">
          <v-window-item
            v-for="(item, index) in homeworks"
            :key="'Component ' + index"
          >
            <v-card
              max-width="700"
              width="80vw"
              flat
              min-height="500"
              class="px-5 py-3 custom-scroll"
              max-height="80vh"
            >
              <v-btn
                color="#FF347C"
                @click="onDelete(index)"
                text
                :absolute="!$vuetify.breakpoint.xs"
                class="text-capitalize d-flex ml-auto"
                style="position: relative;"
              >
                Delete Task
                <v-icon color="#FF347C">mdi-delete</v-icon>
              </v-btn>
              <v-form :ref="'form' + index" @submit.prevent>
                <span class="title font-weight-bold">
                  {{ item.type }}
                </span>
                <component :is="item.type" :data="item" :location="location" />
              </v-form>
            </v-card>
          </v-window-item>
        </template>
      </v-row>
    </v-window>
    <app-selection-dialog
      v-model="selectionDialog"
      :items="items"
      @new-task="newHomework"
    >
      <template #title>
        Select homework type
      </template>
    </app-selection-dialog>
  </div>
</template>
<script>
import Add from './Grammar/Add.vue';
import { deleteHomework, getHomeworks } from '@/api/api';
import SelectionDialog from './Grammar/Selection Dialog.vue';
import Retelling from './Homework/Retelling';
import Monologue from './Homework/Monologue';
import Recording from './Homework/Recording';
import Custom from './Homework/Custom';

export default {
  components: {
    appAdd: Add,
    appSelectionDialog: SelectionDialog,
    Retelling,
    Monologue,
    Custom,
    Recording,
  },
  props: {
    direction: {
      required: false,
      type: String,
      default: '',
    },
    location: {
      type: String,
      default: 'LIVE',
      required: false,
    },
  },
  data() {
    return {
      homeworks: [],
      onboarding: 0,
      selectionDialog: false,
      components: [],
      items: [
        {
          event: 'new-task',
          text: 'Lesson Text Recording',
          component: 'Recording',
        },
        {
          event: 'new-task',
          text: 'Written Retelling',
          component: 'Retelling',
        },
        {
          event: 'new-task',
          text: 'Writing Log',
          component: 'Monologue',
        },
      ],
    };
  },
  methods: {
    async onDelete(index) {
      if (this.homeworks[index].uuid) {
        if (this.direction === 'practice') {
          await deleteHomework(this.homeworks[index].uuid, 'practice');
        } else await deleteHomework(this.homeworks[index].uuid, 'teach');
      }
      this.homeworks.splice(index, 1);
    },
    next() {
      this.onboarding =
        this.onboarding + 1 === this.homeworks.length + 1
          ? 0
          : this.onboarding + 1;
    },
    prev() {
      this.onboarding =
        this.onboarding - 1 < 0 ? this.homeworks.length : this.onboarding - 1;
    },
    newExercise() {
      this.selectionDialog = true;
    },
    newHomework(component) {
      this.homeworks.push({
        teacher_lesson: this.$store.getters['admin/teacher_lesson'].uuid,
        type: component,
        name: component,
        question_group: {
          questions: [],
        },
      });
      this.selectionDialog = false;
      this.onboarding = this.homeworks.length;
    },
    restoreData() {},
    async create() {
      const response = await getHomeworks({
        teacher_lesson__uuid: this.$store.getters['admin/teacher_lesson'].uuid,
        location: this.location,
        not_type: 'Custom',
      });
      this.homeworks = response.data.results;
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.create();
      } else {
        this.components = [];
      }
    },
  },
  created() {
    this.create();
  },
};
</script>
